// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#feedback-container {
  overflow: hidden;
}

#feedback-container .popup {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  height: 90vh;
  margin: 0 5%;
  max-width: 600px;
  overflow: auto;
  padding: 3rem 2rem;
  text-align: left;
  width: 100%;
}

#feedback-container .popup-title {
  font-size: 1.5rem;
  font-weight: bold;
}

#feedback-container .popup-description {
  color: rgba(0, 0, 0, 0.5);
  margin-top: 1rem;
}

#feedback-container .popup-callout {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
}

#feedback-container .popup-actions {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

#feedback-container .popup-action {
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
}

#feedback-container .popup-action:not(:first-of-type) {
  margin-left: 1rem;
}

#feedback-container .popup-action.popup-action-primary {
  background-color: #3E66FB;
  border: 1px solid #3E66FB;
  color: white;
}

#feedback-container .popup-action.popup-action-secondary {
  background-color: white;
  border: 1px solid #C2C9D1;
  color: rgba(0, 0, 0, 0.5);
}

#feedback-container hr {
  border: 1px solid #C2C9D1;
  margin: 3rem 0;
}

#feedback-container .question {
  margin-bottom: 2rem;
}

#feedback-container .radios {
  margin-top: 0.5rem;
}

#feedback-container .radio {
  align-items: center;
  display: flex;
  font-size: 0.875rem;
}

#feedback-container .radio span {
  margin-left: 0.5rem;
}

#feedback-container .sublabel {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.75rem;
  margin-top: 1rem;
}

#feedback-container .stars {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 300px;
}

#feedback-container .stars img {
  padding: 1.5rem 0;
}

#feedback-container input[type="text"] {
  border: 1px solid #C2C9D1;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  padding: 0.5rem;
  width: 100%;
}

#feedback-container input[type="text"]::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

#feedback-container textarea {
  border: 1px solid #C2C9D1;
  border-radius: 8px;
  font-size: 0.875rem;
  height: 120px;
  margin-top: 0.5rem;
  padding: 0.5rem;
  resize: none;
  width: 100%;
}

#feedback-container textarea::placeholder {
  color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/components/feedback/Feedback.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["#feedback-container {\n  overflow: hidden;\n}\n\n#feedback-container .popup {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  height: 90vh;\n  margin: 0 5%;\n  max-width: 600px;\n  overflow: auto;\n  padding: 3rem 2rem;\n  text-align: left;\n  width: 100%;\n}\n\n#feedback-container .popup-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n#feedback-container .popup-description {\n  color: rgba(0, 0, 0, 0.5);\n  margin-top: 1rem;\n}\n\n#feedback-container .popup-callout {\n  color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n}\n\n#feedback-container .popup-actions {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-top: 3rem;\n}\n\n#feedback-container .popup-action {\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem;\n}\n\n#feedback-container .popup-action:not(:first-of-type) {\n  margin-left: 1rem;\n}\n\n#feedback-container .popup-action.popup-action-primary {\n  background-color: #3E66FB;\n  border: 1px solid #3E66FB;\n  color: white;\n}\n\n#feedback-container .popup-action.popup-action-secondary {\n  background-color: white;\n  border: 1px solid #C2C9D1;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n#feedback-container hr {\n  border: 1px solid #C2C9D1;\n  margin: 3rem 0;\n}\n\n#feedback-container .question {\n  margin-bottom: 2rem;\n}\n\n#feedback-container .radios {\n  margin-top: 0.5rem;\n}\n\n#feedback-container .radio {\n  align-items: center;\n  display: flex;\n  font-size: 0.875rem;\n}\n\n#feedback-container .radio span {\n  margin-left: 0.5rem;\n}\n\n#feedback-container .sublabel {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 0.75rem;\n  margin-top: 1rem;\n}\n\n#feedback-container .stars {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: 300px;\n}\n\n#feedback-container .stars img {\n  padding: 1.5rem 0;\n}\n\n#feedback-container input[type=\"text\"] {\n  border: 1px solid #C2C9D1;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  width: 100%;\n}\n\n#feedback-container input[type=\"text\"]::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n#feedback-container textarea {\n  border: 1px solid #C2C9D1;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  height: 120px;\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  resize: none;\n  width: 100%;\n}\n\n#feedback-container textarea::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
